(function () {
  function initAnnouncementTicker(section) {
    section.querySelectorAll('.announcement-bar__ticker').forEach(function (ticker) {
      if (ticker.dataset.continuousTicker === 'true') return;
      const viewport = ticker.querySelector('.swiper');
      const track = ticker.querySelector('.swiper-wrapper');
      const message = track && track.querySelector('.announcement-bar__message');
      if (!viewport || !track || !message) return;
      ticker.dataset.continuousTicker = 'true';
      const speed = Math.max(1000, Number(ticker.dataset.speed) || 15000);
      const gap = 32;
      let distance = 0;
      let offset = 0;
      let lastTime = null;
      let paused = false;
      let frame;
      viewport.style.overflow = 'hidden';
      track.style.cssText += ';display:flex;width:max-content;gap:32px;transition:none;will-change:transform;';
      function styleMessage(item, duplicate) {
        item.style.cssText += ';flex:0 0 auto;width:max-content;margin:0;';
        if (duplicate) {
          item.setAttribute('aria-hidden', 'true');
          item.querySelectorAll('a,button').forEach(function (link) { link.tabIndex = -1; });
        }
      }
      Array.from(track.children).forEach(function (item, index) { styleMessage(item, index > 0); });
      function measure() {
                distance = message.offsetWidth + gap;
        if (distance <= gap) return;
        const count = Math.max(2, Math.ceil(viewport.clientWidth / distance) + 2);
        while (track.children.length < count) {
          const copy = message.cloneNode(true);
          styleMessage(copy, true);
          track.appendChild(copy);
        }
        offset %= distance;
        track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      }
      function step(time) {
        if (!ticker.isConnected) { observer.disconnect(); return; }
        if (lastTime !== null && !paused && distance > gap) {
          // Wrap by one identical message, so there is no finite end or visible reset.
          offset = (offset + distance / speed * Math.min(time - lastTime, 50)) % distance;
          track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
        }
        lastTime = time;
        frame = requestAnimationFrame(step);
      }
      const observer = new ResizeObserver(measure);
      observer.observe(viewport);
      observer.observe(message);
      measure();
      if (document.fonts) document.fonts.ready.then(measure);
      if (ticker.dataset.pauseOnHover === 'true') {
        ticker.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse') paused = true;
        });
        ticker.addEventListener('pointerleave', function () { paused = false; lastTime = null; });
      }
      ticker.addEventListener('focusin', function () { paused = true; });
      ticker.addEventListener('focusout', function () { paused = false; lastTime = null; });
      document.addEventListener('visibilitychange', function () { lastTime = null; });
      frame = requestAnimationFrame(step);
    });
  }
  initAnnouncementTicker(document);
  if (!window.printedTickerSectionListener) {
    window.printedTickerSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) { initAnnouncementTicker(event.target); });
  }
})();
